export const translations = {
  fr: {
    // Header
    nav: {
      home: "Accueil",
      ged: "Comparer les GED",
      solutions: "Solutions",
      integrations: "Intégrations",
      news: "Ressources",
      about: "À propos"
    },
    subtitle: "Comparateur de logiciels GED pour entreprises",
    
    // Hero
    hero: {
      title: "Trouvez la solution GED idéale pour votre entreprise en moins de 5 minutes",
      description: "Comparez plus de 50 solutions GED, ECM et automatisation documentaire grâce à une analyse IA indépendante.",
      cta: "Démarrer l'analyse IA",
      ctaSecondary: "Voir les solutions",
      faq: "Voir les solutions",
      info: "Questionnaire GED gratuit • Résultats personnalisés en moins de 5 minutes",
      trust1: "Comparaison indépendante",
      trust2: "Résultats personnalisés en moins de 5 minutes",
      trust3: "Compatible ERP, CRM et outils d'entreprise"
    },
    
    // Stats
    stats: {
      simulations: "Simulations",
      productivity: "Productivité",
      roi: "ROI moyen/an",
      automation: "Automatisation",
      countries: "Pays en Europe"
    },
    
    // Analyzer Steps
    analyzer: {
      title: "Analyseur IA de besoins GED",
      subtitle: "Obtenez 3 recommandations adaptées à votre entreprise",
      analyzerCta: "Trouver mon logiciel",
      step1: "Entreprise",
      step2: "Documents & Besoins",
      step3: "Certifications",
      back: "Retour",
      analyze: "Analyser mes besoins",
      next: "Suivant",
      
      // Step 1
      companySize: "Taille de l'entreprise",
      sizes: ["1-10", "11-50", "51-200", "+201"],
      docVolume: "Volume de documents/mois",
      volumes: ["0-100", "100-500", "500-800", "800-1000", "1000-2500", "3000-5000"],
      sector: "Secteur d'activité",
      sectors: ["RH", "Services", "Conseil", "Éducation", "Public", "Administration", "BTP", "Technologie", "Tourisme", "Logistique", "Finance", "Santé", "Industrie", "Commerce"],
      
      // Step 2
      docTypes: "Types de documents",
      documents: ["Factures client", "Factures fournisseur", "Devis", "Contrats", "Documents légaux", "Documents bancaires", "Fiches de paie", "Certificats", "Bons de livraison", "Bons de commande", "Rapports", "Dossiers", "Correspondance", "Manuels", "Plans", "Documents RH"],
      features: "Fonctionnalités prioritaires",
      featuresList: ["OCR", "Recherche", "Workflows", "Sécurité", "ERP/CRM", "Mobile", "Analytics", "Coffre-fort", "Collaboration", "Automatisation"],
      maxFeatures: "max 5",
      deployment: "Mode de déploiement",
      deployments: ["Cloud", "On-premise", "Hybride"],
      priorities: "Priorités",
      prioritiesList: ["Fonctionnalités", "Facilité", "Sécurité", "Integration Friendly", "Eco-Friendly"],
      
      // Step 3
      certifications: "Certifications requises",
      selectCountry: "Sélectionnez un pays pour voir les certifications"
    },
    
    // Countries
    countries: {
      FR: { name: "France", certs: ["ISO/IEC 27001 / 17 / 18 / 14641", "RGPD", "HDS", "NF 461", "eIDAS", "Factur-X", "Chorus Pro"] },
      BE: { name: "Belgique", certs: ["ISO/IEC 27001", "RGPD", "HDS Belgique", "NBN", "eIDAS", "Peppol BIS Billing 3.0"] },
      CH: { name: "Suisse", certs: ["ISO/IEC 27001", "LPD", "SS 584:2020", "HDS Suisse", "ZertES"] },
      LU: { name: "Luxembourg", certs: ["ISO/IEC 27001", "RGPD", "HDS Luxembourg", "LexArchive", "eIDAS", "LuxTrust", "eCDF"] },
      ES: { name: "Espagne", certs: ["ISO/IEC 27001", "RGPD", "ENS", "Ley Crea y Crece", "VeriFactu", "SII IVA", "Facturae", "eIDAS"] },
      IT: { name: "Italie", certs: ["ISO/IEC 27001 / 17 / 18", "RGPD", "AgID", "eIDAS", "SPID", "FatturaPA", "SDI"] },
      PT: { name: "Portugal", certs: ["ISO/IEC 27001 / 17 / 18", "RGPD", "SPMS", "RSE", "eIDAS", "SAF-T"] }
    },
    
    // Results
    results: {
      title: "Vos solutions GED recommandées",
      loading: "Analyse en cours...",
      match: "Correspondance",
      features: "Fonctionnalités",
      deployment: "Déploiement",
      pricing: "Tarification",
      certifications: "Certifications",
      viewMore: "En savoir plus"
    },
    
    // Solutions
    solutions: {
      title: "Solutions GED",
      subtitle: "Les meilleures solutions de gestion documentaire",
      compareOthers: "Comparer avec d'autres solutions"
    },
    
    // Integrations
    integrations: {
      title: "Intégrations",
      subtitle: "Connectez facilement votre GED à vos outils ERP, CRM et logiciels métier.",
      trust: "Compatible avec SAP, Salesforce, Odoo, HubSpot..."
    },
    
    // News
    news: {
      title: "Ressources",
      subtitle: "Les dernières tendances GED",
      readMore: "Lire la suite",
      cta: "Recevez une recommandation en 2 minutes"
    },
    
    // Lead Magnet
    leadMagnet: {
      title: "Téléchargez votre guide maintenant",
      subtitle: "Le guide complet de la gestion documentaire pour les entreprises",
      fields: { name: "Nom", email: "Email", company: "Entreprise (optionnel)" },
      download: "Ouvrir le eBook",
      contents: [
        "Introduction GED",
        "Checklist RGPD + facturation électronique",
        "Comparatif fonctionnalités GED",
        "Cas pratiques",
        "Recommandations + usage Analyste IA"
      ],
      success: "Votre guide sera envoyé à votre adresse email !"
    },
    
    // CTA Final
    ctaFinal: {
      text: "Stoppez la perte de temps à comparer des logiciels",
      cta: "Recevoir ma recommandation"
    },
    
    // Contact
    contact: {
      title: "Contact",
      subtitle: "Une question ? Contactez-nous",
      faqBtn: "FAQs",
      contactBtn: "Contactez-nous",
      name: "Nom",
      email: "Email",
      company: "Entreprise",
      phone: "Téléphone",
      message: "Message",
      send: "Envoyer",
      success: "Message envoyé avec succès !"
    },
    
    // FAQs
    faqs: {
      title: "Questions fréquentes",
      items: [
        { q: "Qu'est-ce qu'une GED ?", a: "La Gestion Électronique de Documents (GED) est un système permettant de dématérialiser, classer, stocker et gérer les documents d'une entreprise de manière numérique." },
        { q: "Comment fonctionne Documatch ?", a: "Documatch analyse vos besoins via un questionnaire intelligent et utilise l'IA pour vous recommander les solutions GED les plus adaptées à votre entreprise." },
        { q: "L'analyse est-elle gratuite ?", a: "Oui, l'analyse de vos besoins et les recommandations sont entièrement gratuites et sans engagement." },
        { q: "Combien de temps prend l'analyse ?", a: "L'analyse complète prend moins de 5 minutes. Vous recevez des recommandations personnalisées instantanément." },
        { q: "Les données sont-elles sécurisées ?", a: "Oui, toutes les données sont traitées conformément au RGPD et ne sont jamais partagées avec des tiers sans votre consentement." },
        { q: "Puis-je comparer plusieurs solutions ?", a: "Oui, Documatch vous présente jusqu'à 3 solutions adaptées à vos besoins avec un score de correspondance détaillé." },
        { q: "Comment contacter le support ?", a: "Vous pouvez nous contacter via le formulaire de contact ou par email. Nous répondons sous 24h ouvrées." }
      ]
    },
    
    // Footer
    footer: {
      copyright: "© 2025 Documatch.eu",
      terms: "Conditions",
      privacy: "Confidentialité",
      legal: "Mentions légales",
      cookies: "Cookies"
    },
    
    // Cookie Banner
    cookie: {
      message: "Nous utilisons des cookies pour améliorer votre expérience IA",
      accept: "Accepter",
      reject: "Refuser",
      settings: "Personnaliser"
    },
    
    // Legal
    legal: {
      terms: {
        title: "Conditions d'utilisation",
        content: `Les présentes conditions définissent les modalités d'accès et d'utilisation du service Documatch, comparateur de solutions GED basé sur l'intelligence artificielle.

Le service est accessible gratuitement à tout utilisateur disposant d'un accès Internet. L'utilisateur s'engage à utiliser le service de manière loyale et conforme à sa finalité.

Documatch ne saurait être tenu responsable des décisions prises sur la base des recommandations fournies, celles-ci étant données à titre informatif et comparatif.

Documatch se réserve le droit de modifier les présentes conditions à tout moment. Les modifications entrent en vigueur dès leur mise en ligne.`
      },
      privacy: {
        title: "Politique de confidentialité",
        content: `Documatch collecte uniquement les données personnelles nécessaires à l'utilisation de son service de comparaison de solutions GED, notamment lors de l'utilisation de l'analyste IA ou d'une prise de contact.

Les données sont utilisées exclusivement pour fournir des recommandations personnalisées, améliorer le service et répondre aux demandes des utilisateurs. Aucune donnée n'est vendue ou transmise à des tiers.

Des mesures de sécurité conformes au RGPD sont mises en œuvre afin de garantir la confidentialité et la protection des données.

Vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données, exerçable à l'adresse info@documatch.eu.`
      },
      legalNotice: {
        title: "Mentions légales",
        content: `Éditeur du site
Documatch est un service de comparaison de solutions de gestion électronique de documents destiné aux entreprises.
Email de contact : info@documatch.eu

Directeur de publication : Documatch
SIREN : 992 752 980, société immatriculée en France
TVA non applicable conformément à l'article 293 B du Code Général des Impôts.

Hébergement
Le site Documatch.eu est hébergé par OVH.
Adresse : 2 rue Kellermann, 59100 Roubaix, France.
Téléphone : +33 9 72 10 10 07.

Propriété intellectuelle
L'ensemble des contenus du site Documatch.eu (textes, visuels, logos, éléments graphiques) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de Documatch ou de ses partenaires. Toute reproduction ou exploitation non autorisée est interdite.

Responsabilité
Documatch s'efforce de fournir des informations fiables et régulièrement mises à jour. Toutefois, aucune garantie n'est apportée quant à l'exactitude ou l'exhaustivité des informations présentées. L'utilisateur reconnaît utiliser ces informations sous sa seule responsabilité.`
      },
      cookiePolicy: {
        title: "Politique des cookies",
        content: `Un cookie est un fichier texte déposé sur votre terminal lors de la consultation du site afin d'assurer son bon fonctionnement, améliorer l'expérience utilisateur et analyser la performance.

Documatch utilise des cookies essentiels, des cookies de préférences et des cookies analytiques. Vous pouvez à tout moment configurer ou supprimer les cookies via les paramètres de votre navigateur.

Contact : info@documatch.eu

Les cookies sont conservés pour une durée maximale de treize mois, conformément à la réglementation en vigueur.`
      }
    },

    // SEO
    seo: {
      title: "Documatch | Comparateur de logiciels GED pour entreprises",
      description: "Comparez les meilleurs logiciels GED et trouvez la solution adaptée à votre entreprise en quelques minutes. Recommandation gratuite et personnalisée.",
      keywords: "logiciel GED, gestion documentaire, comparateur GED, GED PME"
    }
  },
  
  es: {
    // Header
    nav: {
      home: "Inicio",
      ged: "Comparar GED",
      solutions: "Soluciones",
      integrations: "Integraciones",
      news: "Recursos",
      about: "Acerca de"
    },
    subtitle: "Comparador de software de gestión documental para empresas",
    
    // Hero
    hero: {
      title: "Encuentra la solución GED ideal para tu empresa en menos de 5 minutos",
      description: "Compara más de 50 soluciones GED, ECM y automatización documental mediante análisis IA independiente.",
      cta: "Iniciar análisis IA",
      ctaSecondary: "Ver soluciones",
      faq: "Ver soluciones",
      info: "Cuestionario GED gratuito • Resultados personalizados en menos de 5 minutos",
      trust1: "Comparación independiente",
      trust2: "Resultados personalizados en menos de 5 minutos",
      trust3: "Compatible con ERP, CRM y herramientas empresariales"
    },
    
    // Stats
    stats: {
      simulations: "Simulaciones",
      productivity: "Productividad",
      roi: "ROI medio/año",
      automation: "Automatización",
      countries: "Países en Europa"
    },
    
    // Analyzer Steps
    analyzer: {
      title: "Analizador IA de necesidades GED",
      subtitle: "Obtén 3 recomendaciones adaptadas a tu empresa",
      analyzerCta: "Encontrar mi software",
      step1: "Empresa",
      step2: "Documentos y Necesidades",
      step3: "Certificaciones",
      back: "Atrás",
      analyze: "Analizar mis necesidades",
      next: "Siguiente",
      
      companySize: "Tamaño de empresa",
      sizes: ["1-10", "11-50", "51-200", "+201"],
      docVolume: "Volumen de documentos/mes",
      volumes: ["0-100", "100-500", "500-800", "800-1000", "1000-2500", "3000-5000"],
      sector: "Sector de actividad",
      sectors: ["RRHH", "Servicios", "Consultoría", "Educación", "Público", "Administración", "Construcción", "Tecnología", "Turismo", "Logística", "Finanzas", "Salud", "Industria", "Comercio"],
      
      docTypes: "Tipos de documentos",
      documents: ["Facturas cliente", "Facturas proveedor", "Presupuestos", "Contratos", "Documentos legales", "Documentos bancarios", "Nóminas", "Certificados", "Albaranes", "Pedidos", "Informes", "Expedientes", "Correspondencia", "Manuales", "Planos", "Documentos RRHH"],
      features: "Funcionalidades prioritarias",
      featuresList: ["OCR", "Búsqueda", "Workflows", "Seguridad", "ERP/CRM", "Móvil", "Analytics", "Archivo seguro", "Colaboración", "Automatización"],
      maxFeatures: "máx 5",
      deployment: "Modo de despliegue",
      deployments: ["Cloud", "On-premise", "Híbrido"],
      priorities: "Prioridades",
      prioritiesList: ["Funcionalidades", "Facilidad", "Seguridad", "Integración", "Eco-Friendly"],
      
      certifications: "Certificaciones requeridas",
      selectCountry: "Seleccione un país para ver las certificaciones"
    },
    
    // Countries
    countries: {
      ES: { name: "España", certs: ["ISO/IEC 27001", "RGPD", "ENS", "Ley Crea y Crece", "VeriFactu", "SII IVA", "Facturae", "eIDAS"] },
      IT: { name: "Italia", certs: ["ISO/IEC 27001 / 17 / 18", "RGPD", "AgID", "eIDAS", "SPID", "FatturaPA", "SDI"] },
      PT: { name: "Portugal", certs: ["ISO/IEC 27001 / 17 / 18", "RGPD", "SPMS", "RSE", "eIDAS", "SAF-T"] }
    },
    
    // Results
    results: {
      title: "Sus soluciones GED recomendadas",
      loading: "Análisis en curso...",
      match: "Coincidencia",
      features: "Funcionalidades",
      deployment: "Despliegue",
      pricing: "Precios",
      certifications: "Certificaciones",
      viewMore: "Más información"
    },
    
    // Solutions
    solutions: {
      title: "Soluciones GED",
      subtitle: "Las mejores soluciones de gestión documental",
      compareOthers: "Comparar con otras soluciones"
    },
    
    // Integrations
    integrations: {
      title: "Integraciones",
      subtitle: "Conecta tu GED con tus herramientas ERP y CRM.",
      trust: "Compatible con SAP, Salesforce, Odoo, HubSpot..."
    },
    
    // News
    news: {
      title: "Blog",
      subtitle: "Las últimas tendencias en GED",
      readMore: "Leer más",
      cta: "Recibe una recomendación en 2 minutos"
    },
    
    // Lead Magnet
    leadMagnet: {
      title: "Descarga tu guía ahora",
      subtitle: "La guía completa de gestión documental para empresas",
      fields: { name: "Nombre", email: "Email", company: "Empresa (opcional)" },
      download: "Abrir el eBook",
      contents: [
        "Introducción GED",
        "Checklist RGPD + facturación electrónica",
        "Comparativa funcionalidades GED",
        "Casos prácticos",
        "Recomendaciones + uso Analista IA"
      ],
      success: "¡Tu guía será enviada a tu dirección de email!"
    },
    
    // CTA Final
    ctaFinal: {
      text: "Deja de perder tiempo comparando software",
      cta: "Recibir mi recomendación"
    },
    
    // Contact
    contact: {
      title: "Contacto",
      subtitle: "¿Tiene alguna pregunta? Contáctenos",
      faqBtn: "FAQs",
      contactBtn: "Contáctenos",
      name: "Nombre",
      email: "Email",
      company: "Empresa",
      phone: "Teléfono",
      message: "Mensaje",
      send: "Enviar",
      success: "¡Mensaje enviado con éxito!"
    },
    
    // FAQs
    faqs: {
      title: "Preguntas frecuentes",
      items: [
        { q: "¿Qué es un GED?", a: "El Sistema de Gestión Documental (SGD) es un sistema que permite digitalizar, clasificar, almacenar y gestionar los documentos de una empresa de forma digital." },
        { q: "¿Cómo funciona Documatch?", a: "Documatch analiza sus necesidades mediante un cuestionario inteligente y utiliza IA para recomendarle las soluciones GED más adaptadas a su empresa." },
        { q: "¿El análisis es gratuito?", a: "Sí, el análisis de sus necesidades y las recomendaciones son completamente gratuitas y sin compromiso." },
        { q: "¿Cuánto tiempo toma el análisis?", a: "El análisis completo toma menos de 5 minutos. Recibe recomendaciones personalizadas instantáneamente." },
        { q: "¿Los datos están seguros?", a: "Sí, todos los datos se procesan conforme al RGPD y nunca se comparten con terceros sin su consentimiento." },
        { q: "¿Puedo comparar varias soluciones?", a: "Sí, Documatch le presenta hasta 3 soluciones adaptadas a sus necesidades con una puntuación de coincidencia detallada." },
        { q: "¿Cómo contactar con soporte?", a: "Puede contactarnos a través del formulario de contacto o por email. Respondemos en 24 horas laborables." }
      ]
    },
    
    // Footer
    footer: {
      copyright: "© 2025 Documatch.eu",
      terms: "Términos",
      privacy: "Privacidad",
      legal: "Aviso legal",
      cookies: "Cookies"
    },
    
    // Cookie Banner
    cookie: {
      message: "Utilizamos cookies para mejorar su experiencia IA",
      accept: "Aceptar",
      reject: "Rechazar",
      settings: "Personalizar"
    },
    
    // Legal
    legal: {
      terms: {
        title: "Términos y condiciones",
        content: `Estas condiciones definen las modalidades de acceso y uso del servicio Documatch, comparador de soluciones GED basado en inteligencia artificial.

El servicio es accesible gratuitamente para cualquier usuario con acceso a Internet. El usuario se compromete a utilizar el servicio de manera leal y conforme a su finalidad.

Documatch no será responsable de las decisiones tomadas sobre la base de las recomendaciones proporcionadas, las cuales se dan a título informativo y comparativo.

Documatch se reserva el derecho de modificar estas condiciones en cualquier momento. Las modificaciones entran en vigor desde su publicación en línea.`
      },
      privacy: {
        title: "Política de privacidad",
        content: `Documatch recopila únicamente los datos personales necesarios para el uso de su servicio de comparación de soluciones GED, especialmente durante el uso del analista IA o una solicitud de contacto.

Los datos se utilizan exclusivamente para proporcionar recomendaciones personalizadas, mejorar el servicio y responder a las solicitudes de los usuarios. Ningún dato se vende ni se transmite a terceros.

Se implementan medidas de seguridad conformes al RGPD para garantizar la confidencialidad y protección de los datos.

Usted tiene derecho de acceso, rectificación, eliminación y portabilidad de sus datos, ejercitable en info@documatch.eu.`
      },
      legalNotice: {
        title: "Aviso legal",
        content: `Editor del sitio
Documatch es un servicio de comparación de soluciones de gestión electrónica de documentos destinado a empresas.
Email de contacto: info@documatch.eu

Director de publicación: Documatch
SIREN: 992 752 980, sociedad registrada en Francia
IVA no aplicable conforme al artículo 293 B del Código General de Impuestos.

Alojamiento
El sitio Documatch.eu está alojado por OVH.
Dirección: 2 rue Kellermann, 59100 Roubaix, Francia.
Teléfono: +33 9 72 10 10 07.

Propiedad intelectual
Todo el contenido del sitio Documatch.eu (textos, imágenes, logotipos, elementos gráficos) está protegido por el derecho de propiedad intelectual y es propiedad exclusiva de Documatch o sus socios. Cualquier reproducción o explotación no autorizada está prohibida.

Responsabilidad
Documatch se esfuerza por proporcionar información fiable y actualizada regularmente. Sin embargo, no se garantiza la exactitud o exhaustividad de la información presentada. El usuario reconoce utilizar esta información bajo su propia responsabilidad.`
      },
      cookiePolicy: {
        title: "Política de cookies",
        content: `Una cookie es un archivo de texto depositado en su dispositivo durante la consulta del sitio para asegurar su correcto funcionamiento, mejorar la experiencia del usuario y analizar el rendimiento.

Documatch utiliza cookies esenciales, cookies de preferencias y cookies analíticas. Puede configurar o eliminar las cookies en cualquier momento a través de la configuración de su navegador.

Contacto: info@documatch.eu

Las cookies se conservan por un período máximo de trece meses, conforme a la normativa vigente.`
      }
    },

    // SEO
    seo: {
      title: "Documatch | Comparador de software de gestión documental",
      description: "Compara los mejores software de gestión documental y encuentra la solución ideal para tu empresa en minutos. Recomendación gratuita y personalizada.",
      keywords: "software gestión documental, comparador GED, GED empresas"
    }
  },
  
  en: {
    // Header
    nav: {
      home: "Home",
      ged: "Compare DMS",
      solutions: "Solutions",
      integrations: "Integrations",
      news: "Resources",
      about: "About"
    },
    subtitle: "Document Management Software Comparison Platform",
    
    // Hero
    hero: {
      title: "Find the ideal DMS solution for your company in less than 5 minutes",
      description: "Compare 50+ DMS, ECM and document automation solutions with independent AI analysis.",
      cta: "Start AI analysis",
      ctaSecondary: "View solutions",
      faq: "View solutions",
      info: "Free DMS questionnaire • Personalized results in less than 5 minutes",
      trust1: "Independent comparison",
      trust2: "Personalized results in under 5 minutes",
      trust3: "Compatible with ERP, CRM and business tools"
    },
    
    // Stats
    stats: {
      simulations: "Simulations",
      productivity: "Productivity",
      roi: "Avg ROI/year",
      automation: "Automation",
      countries: "Countries in Europe"
    },
    
    // Analyzer Steps
    analyzer: {
      title: "AI DMS Needs Analyzer",
      subtitle: "Get 3 tailored recommendations for your business",
      analyzerCta: "Find my software",
      step1: "Company",
      step2: "Documents & Needs",
      step3: "Certifications",
      back: "Back",
      analyze: "Analyze my needs",
      next: "Next",
      
      companySize: "Company size",
      sizes: ["1-10", "11-50", "51-200", "+201"],
      docVolume: "Document volume/month",
      volumes: ["0-100", "100-500", "500-800", "800-1000", "1000-2500", "3000-5000"],
      sector: "Business sector",
      sectors: ["HR", "Services", "Consulting", "Education", "Public", "Administration", "Construction", "Technology", "Tourism", "Logistics", "Finance", "Healthcare", "Industry", "Commerce"],
      
      docTypes: "Document types",
      documents: ["Customer invoices", "Supplier invoices", "Quotes", "Contracts", "Legal documents", "Bank documents", "Payslips", "Certificates", "Delivery notes", "Purchase orders", "Reports", "Files", "Correspondence", "Manuals", "Plans", "HR documents"],
      features: "Priority features",
      featuresList: ["OCR", "Search", "Workflows", "Security", "ERP/CRM", "Mobile", "Analytics", "Vault", "Collaboration", "Automation"],
      maxFeatures: "max 5",
      deployment: "Deployment mode",
      deployments: ["Cloud", "On-premise", "Hybrid"],
      priorities: "Priorities",
      prioritiesList: ["Features", "Ease of use", "Security", "Integration Friendly", "Eco-Friendly"],
      
      certifications: "Required certifications",
      selectCountry: "Select a country to view certifications"
    },
    
    // Countries
    countries: {
      FR: { name: "France", certs: ["ISO/IEC 27001 / 17 / 18 / 14641", "RGPD", "HDS", "NF 461", "eIDAS", "Factur-X", "Chorus Pro"] },
      BE: { name: "Belgium", certs: ["ISO/IEC 27001", "RGPD", "HDS Belgique", "NBN", "eIDAS", "Peppol BIS Billing 3.0"] },
      CH: { name: "Switzerland", certs: ["ISO/IEC 27001", "LPD", "SS 584:2020", "HDS Suisse", "ZertES"] },
      LU: { name: "Luxembourg", certs: ["ISO/IEC 27001", "RGPD", "HDS Luxembourg", "LexArchive", "eIDAS", "LuxTrust", "eCDF"] }
    },
    
    // Results
    results: {
      title: "Your recommended DMS solutions",
      loading: "Analysis in progress...",
      match: "Match",
      features: "Features",
      deployment: "Deployment",
      pricing: "Pricing",
      certifications: "Certifications",
      viewMore: "Learn more"
    },
    
    // Solutions
    solutions: {
      title: "DMS Solutions",
      subtitle: "The best document management solutions",
      compareOthers: "Compare with other solutions"
    },
    
    // Integrations
    integrations: {
      title: "Integrations",
      subtitle: "Connect your DMS to your ERP and CRM tools.",
      trust: "Compatible with SAP, Salesforce, Odoo, HubSpot..."
    },
    
    // News
    news: {
      title: "Resources",
      subtitle: "Latest DMS trends",
      readMore: "Read more",
      cta: "Get your recommendation in 2 minutes"
    },
    
    // Lead Magnet
    leadMagnet: {
      title: "Download your guide now",
      subtitle: "The complete document management guide for businesses",
      fields: { name: "Name", email: "Email", company: "Company (optional)" },
      download: "Open the eBook",
      contents: [
        "DMS Introduction",
        "GDPR + e-invoicing checklist",
        "DMS features comparison",
        "Case studies",
        "Recommendations + AI Analyst usage"
      ],
      success: "Your guide will be sent to your email address!"
    },
    
    // CTA Final
    ctaFinal: {
      text: "Stop wasting time comparing software",
      cta: "Get my recommendation"
    },
    
    // Contact
    contact: {
      title: "Contact",
      subtitle: "Have a question? Contact us",
      faqBtn: "FAQs",
      contactBtn: "Contact us",
      name: "Name",
      email: "Email",
      company: "Company",
      phone: "Phone",
      message: "Message",
      send: "Send",
      success: "Message sent successfully!"
    },
    
    // FAQs
    faqs: {
      title: "Frequently Asked Questions",
      items: [
        { q: "What is a DMS?", a: "A Document Management System (DMS) allows you to digitize, classify, store and manage your company's documents digitally." },
        { q: "How does Documatch work?", a: "Documatch analyzes your needs through an intelligent questionnaire and uses AI to recommend the most suitable DMS solutions for your company." },
        { q: "Is the analysis free?", a: "Yes, the needs analysis and recommendations are completely free with no commitment." },
        { q: "How long does the analysis take?", a: "The complete analysis takes less than 5 minutes. You receive personalized recommendations instantly." },
        { q: "Is my data secure?", a: "Yes, all data is processed in accordance with GDPR and is never shared with third parties without your consent." },
        { q: "Can I compare multiple solutions?", a: "Yes, Documatch presents up to 3 solutions tailored to your needs with a detailed match score." },
        { q: "How can I contact support?", a: "You can contact us via the contact form or by email. We respond within 24 business hours." }
      ]
    },
    
    // Footer
    footer: {
      copyright: "© 2025 Documatch.eu",
      terms: "Terms",
      privacy: "Privacy",
      legal: "Legal Notice",
      cookies: "Cookies"
    },
    
    // Cookie Banner
    cookie: {
      message: "We use cookies to improve your AI experience",
      accept: "Accept",
      reject: "Reject",
      settings: "Customize"
    },
    
    // Legal
    legal: {
      terms: {
        title: "Terms of Use",
        content: `These terms define the conditions for accessing and using the Documatch service, an AI-based DMS solution comparator.

The service is freely accessible to any user with Internet access. The user agrees to use the service fairly and in accordance with its purpose.

Documatch cannot be held responsible for decisions made based on the recommendations provided, as these are given for informational and comparative purposes only.

Documatch reserves the right to modify these terms at any time. Changes take effect upon publication online.`
      },
      privacy: {
        title: "Privacy Policy",
        content: `Documatch only collects personal data necessary for the use of its DMS comparison service, particularly when using the AI analyst or submitting a contact request.

Data is used exclusively to provide personalized recommendations, improve the service, and respond to user requests. No data is sold or transmitted to third parties.

GDPR-compliant security measures are implemented to ensure data confidentiality and protection.

You have the right to access, rectify, delete, and port your data, exercisable at info@documatch.eu.`
      },
      legalNotice: {
        title: "Legal Notice",
        content: `Site Publisher
Documatch is a comparison service for electronic document management solutions for businesses.
Contact email: info@documatch.eu

Publication Director: Documatch
SIREN: 992 752 980, company registered in France
VAT not applicable pursuant to Article 293 B of the French General Tax Code.

Hosting
The Documatch.eu website is hosted by OVH.
Address: 2 rue Kellermann, 59100 Roubaix, France.
Phone: +33 9 72 10 10 07.

Intellectual Property
All content on the Documatch.eu website (texts, visuals, logos, graphic elements) is protected by intellectual property law and remains the exclusive property of Documatch or its partners. Any unauthorized reproduction or exploitation is prohibited.

Liability
Documatch strives to provide reliable and regularly updated information. However, no guarantee is given as to the accuracy or completeness of the information presented. The user acknowledges using this information at their own risk.`
      },
      cookiePolicy: {
        title: "Cookie Policy",
        content: `A cookie is a text file stored on your device when you visit the site to ensure its proper functioning, improve the user experience, and analyze performance.

Documatch uses essential cookies, preference cookies, and analytics cookies. You can configure or delete cookies at any time through your browser settings.

Contact: info@documatch.eu

Cookies are retained for a maximum period of thirteen months, in accordance with applicable regulations.`
      }
    },

    // SEO
    seo: {
      title: "Documatch | Document Management Software Comparison Platform",
      description: "Compare the best document management software and find the right solution for your business in minutes. Free personalized recommendation.",
      keywords: "document management software, DMS comparison, DMS for SMEs"
    }
  }
};

export const getCountriesByLanguage = (lang) => {
  const countryGroups = {
    fr: ["FR", "BE", "CH", "LU"],
    es: ["ES", "IT", "PT"],
    en: ["FR", "BE", "CH", "LU", "ES", "IT", "PT"]
  };
  return countryGroups[lang] || countryGroups.fr;
};

